import { render, staticRenderFns } from "./delete-email-template.vue?vue&type=template&id=0ff2884b"
import script from "./delete-email-template.vue?vue&type=script&lang=js"
export * from "./delete-email-template.vue?vue&type=script&lang=js"
import style0 from "./delete-email-template.vue?vue&type=style&index=0&id=0ff2884b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports